// extracted by mini-css-extract-plugin
module.exports = {"root":"xvDr5Pc1","headerWrapper":"_eiV6exr","title":"xJdg_Zgk","loadingSkeletonWrapper":"kf5T00XV"};